import { breakpoints, colors, cssprops, pxToRem } from '@vfit/shared/themes';
import styled, {
  DefaultTheme,
  FlattenSimpleInterpolation,
  ThemedCssFunction,
  css,
} from 'styled-components';
import { IconButtonVariant } from './iconButton.model';

const ButtonVariants: Record<IconButtonVariant, FlattenSimpleInterpolation> = {
  default: css`
    height: ${pxToRem(32)};
    padding: 0;
    width: ${pxToRem(32)};

    @media (min-width: ${breakpoints.tablet}) {
      height: ${pxToRem(36)};
      width: ${pxToRem(36)};
    }
  `,
  circle: css`
    border-radius: 50%;
    background-color: ${colors.$000000_50};
    color: ${colors.$ffffff};
    padding: ${pxToRem(10)};
    width: ${pxToRem(44)};
    height: ${pxToRem(44)};
  `,
};
export const ButtonContainer = styled.button<{ visible: boolean; variant?: IconButtonVariant }>`
  border: none;
  cursor: pointer;
  visibility: ${({ visible }) => (visible ? 'visible' : 'hidden')};
  ${({ variant }) => ButtonVariants[variant || 'default']}
`;

